import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HS_BASE = "/app/health-safety";
export const card = "rounded-[15px] border border-[#e0e6ef] bg-white shadow-[0_3px_10px_rgba(25,48,71,0.045)] dark:border-white/10 dark:bg-[#121c29]";
export const muted = "text-[#677387] dark:text-zinc-400";
export const focusRing = "focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-[#ffab82]";
export const tones = {
  green: "bg-[#e7f8ee] text-[#009e54] dark:bg-emerald-950/50 dark:text-emerald-300",
  blue: "bg-[#e8f0ff] text-[#1956c3] dark:bg-blue-950/50 dark:text-blue-300",
  red: "bg-[#ffeded] text-[#d91828] dark:bg-red-950/50 dark:text-red-300",
  amber: "bg-[#fff5dd] text-[#ef9c00] dark:bg-amber-950/50 dark:text-amber-300",
};
export const pills = {
  green: "bg-[#e1f9eb] text-[#079b54] dark:bg-emerald-950/60 dark:text-emerald-300",
  red: "bg-[#ffe7e8] text-[#d61b2b] dark:bg-red-950/60 dark:text-red-300",
  amber: "bg-[#fff0c9] text-[#c77900] dark:bg-amber-950/60 dark:text-amber-300",
  grey: "bg-[#f1f4f8] text-[#55657a] dark:bg-white/10 dark:text-zinc-300",
};

export const withJob = (path, jobId) => jobId ? `${path}${path.includes("?") ? "&" : "?"}job_id=${encodeURIComponent(jobId)}` : path;

const fmt = new Intl.DateTimeFormat("en-NZ", { day: "numeric", month: "short", timeZone: "UTC" });
const fmtYear = new Intl.DateTimeFormat("en-NZ", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
const thisYear = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Pacific/Auckland" }).format(new Date()).slice(0, 4);
export const shortDate = (iso) => iso ? (iso.slice(0, 4) === thisYear() ? fmt : fmtYear).format(new Date(`${iso.slice(0, 10)}T00:00:00Z`)) : "";

export function PanelHead({ icon: Icon, title, link, linkLabel, testId }) {
  return <div className="mb-4 flex items-center justify-between gap-3">
    <h2 className="flex items-center gap-2.5 text-[17px] font-bold tracking-[-0.35px] text-[#101820] dark:text-zinc-100"><Icon className="h-5 w-5 shrink-0" strokeWidth={2.2} />{title}</h2>
    {link && <Link to={link} data-testid={testId} className={`group inline-flex min-h-9 items-center gap-1 rounded-md px-1 text-[13px] font-bold text-[#e6471a] hover:text-[#FF5F15] ${focusRing}`}>{linkLabel}<ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" /></Link>}
  </div>;
}

export function Empty({ children, testId }) {
  return <p data-testid={testId} className={`rounded-xl border border-dashed border-[#e0e6ef] px-4 py-6 text-center text-xs dark:border-white/10 ${muted}`}>{children}</p>;
}
